module.exports = __webpack_public_path__ + "img/next.1442ff55.svg";